import { useState, useRef, useEffect } from "react";
import { Button, ListGroup } from "react-bootstrap";
import { IoChevronDown, IoClose, IoCloseOutline } from "react-icons/io5";

export default function SelectDropdown({
  disabled,
  searchable = true,
  clearButton = false,
  maxHeight = 180,
  options,
  labelField,
  valueField,
  searchPlaceholder,
  placeholder,
  selectedValue,
  onSelect,
  containerClass,
  menuClass = "border rounded",
  inputClass = "form-control"
}) {

  const dropdownRef = useRef(null);

  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSearch("");
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const transformArrayForDropdown = (array, labelField, valueField) => {
    return array && array.map((obj) => ({
      label: obj[labelField],
      value: obj[valueField]
    }));
  };

  const dropdownOptions = transformArrayForDropdown(options, labelField, valueField);

  const filteredObjects = dropdownOptions && dropdownOptions.filter(item => item.label.toLowerCase().includes(search));

  return (
    <div className={`position-relative ${containerClass}`} ref={dropdownRef}>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="cursor-pointer"
      >
        {
          isOpen ?
            <input
              readOnly={searchable ? false : true}
              type="text"
              className={`${inputClass} ${searchable ? '' : 'cursor-pointer'}`}
              placeholder={searchable ? searchPlaceholder : placeholder}
              onClick={() => setIsOpen(false)}
              onChange={(event) => setSearch(event.target.value)}
              value={search && search}
            />
            :
            <input
              readOnly
              disabled={disabled && disabled}
              type="text"
              placeholder={placeholder}
              className={inputClass}
              onClick={() => setIsOpen(true)}
              value={selectedValue ? selectedValue : ""}
            />
        }
        {
          selectedValue && selectedValue && clearButton ?
            <div className="position-absolute end-0 bottom-0 top-0 h-100 d-flex align-items-center justify-content-center">
              <Button
                variant="white"
                className="p-1 px-2"
                onClick={() => {
                  setIsOpen(false);
                  onSelect("");
                  setSearch("");
                }}
              >
                <IoCloseOutline size={18} />
              </Button>
            </div>
            :
            <div className="position-absolute end-0 bottom-0 top-0 h-100 d-flex align-items-center justify-content-center px-2">
              <IoChevronDown className="" />
            </div>
        }
      </div>
      {
        isOpen && filteredObjects &&
        (
          <div
            className={`position-absolute start-0 end-0 bg-white mt-1 border rounded overflow-hidden overflow-scroll ${menuClass}`}
            style={{ zIndex: 9999, maxHeight }}
          >
            <ListGroup variant="flush">
              {
                filteredObjects && filteredObjects.length > 0 ?
                  <>
                    {
                      filteredObjects && filteredObjects.map((option, index) => {
                        return (
                          <ListGroup.Item key={index} action onClick={() => {
                            onSelect(option.value);
                            setSearch("");
                            setIsOpen(false);
                          }}>
                            {option.label}
                          </ListGroup.Item>
                        )
                      })
                    }
                  </>
                  :
                  <div className="p-3 py-2 bg-light">
                    <div className="text-center text-muted small">No Option</div>
                  </div>
              }
            </ListGroup>
          </div>
        )
      }
    </div >
  );
}
